import { render, staticRenderFns } from "./input-label.vue?vue&type=template&id=2bdba8cc&"
import script from "./input-label.vue?vue&type=script&lang=js&"
export * from "./input-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports